export default __webpack_public_path__ + "static/media/Ontime.6779f4c0.svg";